import { Route as AppRoute } from "utilities/app-routes";

export const getSmsSimulatorTabRoute = (tabName: string) => {
  const url = `${AppRoute.smsSimulator}/`;

  switch (tabName) {
    case "Personas":
      return url + AppRoute.personas;
    case "Simulator":
      return url + AppRoute.simulator;
    default:
      return url + AppRoute.rules;
  }
};
